import { fetchJSON as fetchAPI } from './client';

export type BriefingSection = {
  title: string;
  summary: string;
  items?: string[];
  priority?: string;
  action_url?: string;
  requires_approval?: boolean;
};

export type DailyBriefing = {
  tenant_id: string;
  workspace_id: string;
  date: string;
  greeting: string;
  sections: BriefingSection[];
  alert_count: number;
  task_count: number;
  generated_at: string;
};

export type CopilotInsight = {
  id: string;
  type: string;
  title: string;
  description: string;
  confidence: number;
  impact?: number;
  action?: string;
  requires_approval: boolean;
  created_at: string;
};

export type CopilotDashboardSummary = {
  tenant_id: string;
  workspace_id?: string;
  active_sessions: number;
  total_recommendations: number;
  pending_insights: number;
  insights?: CopilotInsight[];
  latest_briefing?: DailyBriefing;
  generated_at: string;
};

export type AgentBrief = {
  id: string;
  type: string;
  name: string;
  description: string;
  status: string;
  last_active?: string;
  tasks_open: number;
};

const API_BASE = import.meta.env.VITE_COPILOT_API ?? '/api/v1/copilot';

function fetchJSON<T>(path: string, init?: RequestInit): Promise<T> {
  return fetchAPI<T>(API_BASE, path, init);
}

export const copilotApi = {
  dashboard: (workspaceId?: string) =>
    fetchJSON<CopilotDashboardSummary>(`/dashboard${workspaceId ? `?workspace_id=${workspaceId}` : ''}`),

  briefing: (workspaceId?: string) =>
    fetchJSON<DailyBriefing>(`/briefing${workspaceId ? `?workspace_id=${workspaceId}` : ''}`),

  agents: (workspaceId?: string) =>
    fetchJSON<AgentBrief[]>(`/agents${workspaceId ? `?workspace_id=${workspaceId}` : ''}`),

  insights: (workspaceId?: string) =>
    fetchJSON<CopilotInsight[]>(`/insights${workspaceId ? `?workspace_id=${workspaceId}` : ''}`),
};
